import { Switch } from "@headlessui/react";
import WhiteCross from "assets/images/icons/white-cross.svg";
import WhiteTick from "assets/images/icons/white-tick.svg";

type Props = {
  checked: boolean;
  onChange(checked: boolean): void;
  height?: number;
  width?: number;
  toggleDims?: number;
  translateAmount?: number;
  id?: string;
  className?: string;
};

export default function Toggle({
  checked,
  onChange,
  width,
  height,
  toggleDims,
  translateAmount,
  id,
  className
}: Props) {
  return (
    <Switch
      checked={checked}
      onChange={onChange}
      className={`
        ${ checked ? "bg-dpGreen" : "bg-red-600" }
        ${ className || "" }
        relative inline-flex shrink-0 cursor-pointer rounded-full border-2 border-transparent
        transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2
        focus-visible:ring-white focus-visible:ring-opacity-75 h-${
    height || 7
    } w-${width || 14}
      `}
      id={id || ""}
    >
      <span className="sr-only">Use setting</span>
      <span
        aria-hidden="true"
        className={`
          absolute h-${toggleDims || 6} w-${toggleDims || 6} py-2 px-1
          ${checked ? "left-1" : "right-1"}
        `}
      >
        {
          checked
            ? <img src={WhiteTick} className="w-full h-full" alt="white-tick-icon"/>
            : <img src={WhiteCross} className="w-full h-full" alt="white-cross-icon"/>
        }
      </span>
      <span
        aria-hidden="true"
        className={`
          ${
    checked
      ? `translate-x-${translateAmount || 7}`
      : "translate-x-0"
    }
          pointer-events-none inline-block
          transform rounded-full bg-white shadow-lg ring-0 transition duration-200
          ease-in-out h-${toggleDims || 6} w-${toggleDims || 6}
        `}
      />
    </Switch>
  );
}
